import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {SynthesisService} from "../../synthesis.service";
import {FrAcCustomGroupSummaryMapper} from "./fr.ac.custom-group-summary.mapper";

export class FrAcSynthesisService extends SynthesisService {

    constructor(protected translationService: TranslationServiceInterface) {
        super(new FrAcCustomGroupSummaryMapper(translationService), translationService);
    }

}
